import React from 'react'
import ds from '../assets/ds.jpg'
const DS = () => {
  return (
   <div className="min-h-screen bg-[#0A0F20] flex flex-col items-center justify-center p-6">
         <h1 className="text-3xl md:text-4xl font-bold text-white mb-6 text-center">
           Data Science Roadmap for Beginners
         </h1>
         <div className="bg-gray-800 p-4 rounded-lg shadow-lg max-w-4xl w-full">
           <img
             src={ds}
             alt="Java Roadmap "
             className="w-full h-auto rounded-md"
           />
         </div>
       </div>
  )
}

export default DS
